import { cx, useTranslations } from "@jugl-web/utils";
import { PlainButton } from "@jugl-web/ui-components/cross-platform/PlainButton";
import { Collapse } from "@jugl-web/ui-components/cross-platform/Collapse";
import { useState } from "react";
import { ReactComponent as PopularTemplatesIcon } from "./assets/popular-templates.svg";
import { ReactComponent as BluePopularTemplatesIcon } from "./assets/popular-templates-blue.svg";
import { ReactComponent as ArrowUpIcon } from "./assets/arrow-up.svg";
import { useBoardTemplatesCategories } from "../../../../hooks/useBoardTemplatesCategories";
import { useBoardTemplatesModalProvider } from "../../../../providers/useBoardTemplatesModalProvider";

export const BoardTemplatesSidebar = () => {
  const { t } = useTranslations();
  const { selectedCategory, setSelectedCategory } =
    useBoardTemplatesModalProvider();
  const [collapseState, setCollapseState] = useState<{
    [key: string]: boolean;
  }>({});
  const { categories, subcategories } = useBoardTemplatesCategories();

  return (
    <div className="flex w-[320px] flex-col justify-center py-8 px-4">
      <div className="border-dark-200 mb-8 w-full border-0 border-b-[1px] border-solid pb-8">
        <PlainButton
          className={cx(
            "font-secondary text-dark flex h-[54px] w-full items-center gap-2 rounded-[12px] px-4 text-base font-medium leading-[160%] transition-all",
            {
              "bg-[#EFF8FF]": selectedCategory === "popular-templates",
            }
          )}
          onClick={() => setSelectedCategory("popular-templates")}
        >
          {selectedCategory === "popular-templates" ? (
            <BluePopularTemplatesIcon />
          ) : (
            <PopularTemplatesIcon />
          )}
          {t({
            id: "board-templates-modal.popular-templates",
            defaultMessage: "Popular Templates",
          })}
        </PlainButton>
      </div>
      {categories.map((category) => {
        if (category === "popular-templates") {
          return null;
        }
        return (
          <div className="flex w-full flex-col gap-2" key={category}>
            <PlainButton
              onClick={() => {
                setCollapseState((prev) => ({
                  ...prev,
                  [category]: !prev[category],
                }));
              }}
              className="text-dark font-secondary flex h-[54px] w-full items-center justify-between px-4 text-left text-base font-medium transition-all"
            >
              {category}
              <ArrowUpIcon
                className={cx(
                  "transition",
                  !collapseState[category] && "rotate-180"
                )}
              />
            </PlainButton>
            <Collapse
              key={category}
              className="w-full"
              isOpen={collapseState[category] || false}
            >
              <div className="flex flex-col gap-2">
                {subcategories.get(category).map((subcategory: string) => (
                  <PlainButton
                    key={category}
                    className={cx(
                      "font-secondary text-dark-700 flex h-[54px] w-full items-center gap-2 truncate rounded-[12px] px-8 text-left text-base leading-[160%] transition-all hover:bg-[#F5F7FA]",
                      {
                        "text-dark bg-[#EFF8FF] font-medium":
                          selectedCategory === `${category}-${subcategory}`,
                      }
                    )}
                    onClick={() =>
                      setSelectedCategory(`${category}-${subcategory}`)
                    }
                  >
                    <div className="w-full truncate" title={subcategory}>
                      {subcategory}
                    </div>
                  </PlainButton>
                ))}
              </div>
            </Collapse>
          </div>
        );
      })}
    </div>
  );
};
